import React from "react";
import Button from "../../common/Button/Button";

import img1 from "../../images/oha/img (4).jpg";
import img2 from "../../images/oha/img (19).jpg";
import img3 from "../../images/activities/soccor/img (3).jpg";

const RecentActivities = () => {
  const activities = [
    {
      title: "New Sewing Program Launch",
      date: "January 2026",
      description: "Launched women's self-sufficiency sewing classes at OHA, empowering women with valuable skills for economic independence.",
      image: img1,
      imageAlt: "Women learning sewing skills",
      type: "Program Launch"
    },
    {
      title: "150 Students Enrolled",
      date: "February 2026",
      description: "Sedaqat Educational Center now serves 140 students from grades 1-6 with comprehensive daily lessons in multiple subjects.",
      image: img2,
      imageAlt: "Students in classroom setting",
      type: "Milestone"
    },
    {
      title: "Soccer Tournament Success",
      date: "December 2025",
      description: "Our Indoor Soccer Team participated in regional tournaments, winning 2nd place and promoting teamwork and physical education.",
      image: img3,
      imageAlt: "Children celebrating soccer victory",
      type: "Achievement"
    }
  ];

  return (
    <div className="recent-activities" data-aos="fade-up">
      <h2 data-aos="fade-down" data-aos-delay="100">
        Recent Activities & Updates
      </h2>
      
      <div className="activities-grid">
        {activities.map((activity, index) => (
          <div 
            key={index} 
            className="activity-card"
            data-aos="fade-up"
            data-aos-delay={200 + (index * 100)}
          >
            <div className="activity-image-container">
              <img 
                src={activity.image} 
                alt={activity.imageAlt}
                loading="lazy"
              />
            </div>
            
            <div className="activity-content">
              <div className="activity-type">{activity.type}</div>
              <h3>{activity.title}</h3>
              <span className="activity-date">{activity.date}</span>
              <p>{activity.description}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="activities-cta" data-aos="zoom-in" data-aos-delay="500">
        <h3>Want to see more of our work?</h3>
        <p>Explore our complete timeline of achievements, events, and community impact.</p>
        <Button
          className="btns"
          buttonStyle="btn--primary"
          buttonSize="btn--large"
          src="news"
          newTab="false"
        >
          View All Activities
        </Button>
      </div>
    </div>
  );
};

export default RecentActivities;